// Angular imports
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { Router } from '@angular/router';

// 3rd party imports
import { DxValidationGroupComponent } from 'devextreme-angular';

// Component imports
import { IconConstants } from '@therealmanage/ciranet-ui-common';
import { RecaptchaBaseComponent } from '../../_base/recaptcha-base.component';

// Service imports
import { EnvironmentConfigService } from '../../_services/environment-config.service';
import { UserService } from '../../_services/data-services/user.service';
import { ScreenService } from '../../_services/shared-services/screen.service';
import { ServerErrorService } from '../../_services/shared-services/server-error.service';

// Model imports
import { ForgotPasswordTokenParametersDto } from '../../_models/forgot-password-token-parameters-dto';

// CC-Common imports
import { RxjsUtils } from '@therealmanage/ciranet-ui-common';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  standalone: false
})
export class ForgotPasswordComponent
  extends RecaptchaBaseComponent
  implements OnInit
{
  @ViewChild('forgotPasswordValidationGroup', { static: false })
  forgotPasswordValidationGroup: DxValidationGroupComponent;

  @Input() isEmbedded = false;
  @Output() closePanel = new EventEmitter<void>();

  isSmallScreen = false;
  loadingVisible = false;
  isResetEmailSent = false;
  forgotPasswordParameterDto: ForgotPasswordTokenParametersDto =
    new ForgotPasswordTokenParametersDto();

  backToLoginIcon = IconConstants.BACK_TO_LOGIN;
  submitIcon = IconConstants.SUBMIT;

  constructor(
    private router: Router,
    private userService: UserService,
    private screenService: ScreenService,
    protected override errorService: ServerErrorService,
    protected override envConfig: EnvironmentConfigService
  ) {
    super(errorService, envConfig);
  }

  ngOnInit() {
    this.updateScreenSize();
    RxjsUtils.safeSubscribe(this.screenService.changed, () =>
      this.updateScreenSize()
    );
  }

  btnResetPasswordClick(event: any): void {
    const validator = this.forgotPasswordValidationGroup.instance.validate();
    if (validator.isValid && this.isValidRecaptcha()) {
      this.forgotPasswordParameterDto.recaptchaToken = this.recaptchaToken;
      this.doResetPassword().then(() => this.resetRecaptcha());
    }
  }

  btnBackToLogin(event: any): void {
    if (this.isEmbedded) {
      this.closePanel.emit();
    } else {
      this.router.navigate(['user', 'login']);
    }
  }

  private doResetPassword(): Promise<void> {
    return new Promise((resolve) => {
      this.loadingVisible = true;

      RxjsUtils.safeSubscribe(
        this.userService.forgotPassword(this.forgotPasswordParameterDto),
        () => {
          resolve();
          this.loadingVisible = false;
          this.isResetEmailSent = true;
        },
        (error) => {
          resolve();
          this.loadingVisible = false;
          this.processApiError(error);
        }
      );
    });
  }

  private updateScreenSize(): void {
    this.isSmallScreen = this.screenService.isSmallScreen();
  }
}
